module.exports = __webpack_public_path__ + "img/c05_buildingtechpraesidium_Normal_ua.0d2cf742.webp";